/**
 * @generated SignedSource<<691eac21e1e168a27bec375cf430497a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskProblemTypingCompleteInput = {
  task: string;
};
export type TaskActionsMutationButtonStack_taskProblemTypingCompleteMutation$variables = {
  input: TaskProblemTypingCompleteInput;
};
export type TaskActionsMutationButtonStack_taskProblemTypingCompleteMutation$data = {
  readonly taskProblemTypingComplete: {
    readonly completedBy: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
    } | null;
    readonly id: string;
    readonly showLabeling: boolean;
    readonly showProblem: boolean;
    readonly showSolutionVideo: boolean;
    readonly showVideo: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"TaskActionsMutationButtonStack_task" | "TaskDescriptionList_task" | "TaskStatusLabel_task" | "TaskTaskHistoryPaginator_task">;
  };
};
export type TaskActionsMutationButtonStack_taskProblemTypingCompleteMutation = {
  response: TaskActionsMutationButtonStack_taskProblemTypingCompleteMutation$data;
  variables: TaskActionsMutationButtonStack_taskProblemTypingCompleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showProblem",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showLabeling",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showVideo",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSolutionVideo",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = [
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "order": "DESC"
    }
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v13 = [
  (v2/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitATitle",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitBTitle",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitCTitle",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficulty",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "UnitD",
  "kind": "LinkedField",
  "name": "unitDs",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": "unitDs(order:{\"order\":\"DESC\"})"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v20 = [
  (v2/*: any*/),
  (v19/*: any*/)
],
v21 = [
  (v2/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "originalTask",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = [
  (v2/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/)
],
v24 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "created": "DESC"
    }
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "before",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "after",
  "storageKey": null
},
v28 = [
  (v25/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Diff",
  "kind": "LinkedField",
  "name": "problem",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Diff",
  "kind": "LinkedField",
  "name": "solution",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v31 = [
  (v29/*: any*/),
  (v30/*: any*/)
],
v32 = [
  (v26/*: any*/),
  (v27/*: any*/),
  (v25/*: any*/)
],
v33 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "difficulty",
    "plural": false,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "unitDs",
    "plural": true,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "problem",
    "plural": false,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "solution",
    "plural": false,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "answer",
    "plural": false,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "answerChoiceCount",
    "plural": false,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "answerType",
    "plural": false,
    "selections": (v32/*: any*/),
    "storageKey": null
  }
],
v34 = [
  (v26/*: any*/),
  (v27/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskActionsMutationButtonStack_taskProblemTypingCompleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "taskProblemTypingComplete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "completedBy",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserAvatarText_user"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskActionsMutationButtonStack_task"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskDescriptionList_task"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskStatusLabel_task"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskTaskHistoryPaginator_task"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskActionsMutationButtonStack_taskProblemTypingCompleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "taskProblemTypingComplete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "completedBy",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "assignedTo",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskHint",
            "kind": "LinkedField",
            "name": "hint",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskSubmitFeedback",
            "kind": "LinkedField",
            "name": "submitFeedback",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "specialAnswer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "special",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "general",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Course",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "year",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "UnitD",
            "kind": "LinkedField",
            "name": "publishedUnitDs",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "nextUnitD",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "previousUnitD",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": "publishedUnitDs(order:{\"order\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMigrated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "migrationPair",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sequence",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskProblem",
            "kind": "LinkedField",
            "name": "problem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "problem",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "solution",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creationType",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "problemType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "answer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "answerType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "answerChoiceCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "aiFile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "objectUrl",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskLabeling",
            "kind": "LinkedField",
            "name": "finalLabeling",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inMigrationPairSync",
            "storageKey": null
          },
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Scrap",
            "kind": "LinkedField",
            "name": "scrap",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ScrapSource",
                "kind": "LinkedField",
                "name": "scrapSource",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assigned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProblemGenerator",
            "kind": "LinkedField",
            "name": "problemGenerator",
            "plural": false,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GeneratedProblem",
            "kind": "LinkedField",
            "name": "generatedProblem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProblemGenerator",
                "kind": "LinkedField",
                "name": "problemGenerator",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v22/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "migrationDifficultyNeedsReview",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DerivedTaskGroup",
            "kind": "LinkedField",
            "name": "derivedTaskGroups",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "labelingCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskLabeling",
            "kind": "LinkedField",
            "name": "firstLabeling",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskLabeling",
            "kind": "LinkedField",
            "name": "secondLabeling",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiDifficulty",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TypingAutomationScript",
            "kind": "LinkedField",
            "name": "typingAutomationScript",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": "TaskHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v2/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v31/*: any*/),
                            "type": "TaskProblemTypingDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "answerType",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "answer",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "answerChoiceCount",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              (v29/*: any*/),
                              (v30/*: any*/)
                            ],
                            "type": "TaskProblemCreationDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v31/*: any*/),
                            "type": "TaskImageCreationDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v33/*: any*/),
                            "type": "TaskFirstLabelingDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v33/*: any*/),
                            "type": "TaskSecondLabelingDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v33/*: any*/),
                            "type": "TaskPublishDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v34/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "teacherName",
                                "plural": false,
                                "selections": (v34/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "title",
                                "plural": false,
                                "selections": (v34/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "type",
                                "plural": false,
                                "selections": (v34/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskVideoDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "isPremium",
                                "plural": false,
                                "selections": (v34/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "isRecommended",
                                "plural": false,
                                "selections": (v34/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "taskVideoTitle",
                                "plural": false,
                                "selections": (v34/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "thumbnailHorizontalUrl",
                                "plural": false,
                                "selections": (v34/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "thumbnailVerticalUrl",
                                "plural": false,
                                "selections": (v34/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskSolutionVideoDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "hint",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "specialAnswer",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "special",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "general",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "incorrect",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "correct",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskHintFeedbackDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "title",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "originalTask",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "creationType",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "assignedTo",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10,order:{\"created\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "filters": [
              "filters",
              "order"
            ],
            "handle": "connection",
            "key": "TaskTaskHistoryPaginator_task_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "65b0b1a456c533e51af7452e1e61e5fe",
    "id": null,
    "metadata": {},
    "name": "TaskActionsMutationButtonStack_taskProblemTypingCompleteMutation",
    "operationKind": "mutation",
    "text": "mutation TaskActionsMutationButtonStack_taskProblemTypingCompleteMutation(\n  $input: TaskProblemTypingCompleteInput!\n) {\n  taskProblemTypingComplete(input: $input) {\n    id\n    showProblem\n    showLabeling\n    showVideo\n    showSolutionVideo\n    completedBy {\n      id\n      ...UserAvatarText_user\n    }\n    ...TaskActionsMutationButtonStack_task\n    ...TaskDescriptionList_task\n    ...TaskStatusLabel_task\n    ...TaskTaskHistoryPaginator_task\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment TaskActionsMutationButtonStack_task on Task {\n  id\n  actions\n  assignedTo {\n    id\n  }\n  ...TaskHintFeedbackPublishDialog_task\n  ...TaskMigrateDialog_task\n  ...TaskMigrationPairSyncDialog_task\n  difficulty\n  publishedUnitDs(order: {order: DESC}) {\n    id\n  }\n  finalLabeling {\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n    }\n    id\n  }\n  inMigrationPairSync\n  problem {\n    id\n    problem\n    solution\n  }\n}\n\nfragment TaskDescriptionList_task on Task {\n  id\n  title\n  problem {\n    id\n    problemType\n    creationType\n    answer\n    answerType\n    answerChoiceCount\n  }\n  scrap {\n    id\n    scrapSource {\n      id\n      title\n    }\n  }\n  ...TaskStatusLabel_task\n  assignedTo {\n    id\n    ...UserAvatarText_user\n  }\n  assigned\n  aiFile {\n    id\n    objectUrl\n  }\n  problemGenerator {\n    id\n  }\n  generatedProblem {\n    id\n    problemGenerator {\n      id\n      originalTask {\n        id\n      }\n    }\n  }\n  originalTask {\n    id\n  }\n  isMigrated\n  migrationDifficultyNeedsReview\n  derivedTaskGroups {\n    kind\n    count\n  }\n  migrationPair {\n    id\n  }\n  labelingCount\n  firstLabeling {\n    id\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n      unitATitle\n      unitBTitle\n      unitCTitle\n      description\n    }\n  }\n  secondLabeling {\n    id\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n      unitATitle\n      unitBTitle\n      unitCTitle\n      description\n    }\n  }\n  finalLabeling {\n    id\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n      unitATitle\n      unitBTitle\n      unitCTitle\n      description\n    }\n  }\n  unitDs(order: {order: DESC}) {\n    id\n    unitATitle\n    unitBTitle\n    unitCTitle\n    description\n  }\n  publishedUnitDs(order: {order: DESC}) {\n    id\n    unitATitle\n    unitBTitle\n    unitCTitle\n    description\n  }\n  difficulty\n  aiDifficulty\n  typingAutomationScript {\n    id\n    title\n  }\n}\n\nfragment TaskDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskDifference {\n    title {\n      __typename\n    }\n    description {\n      __typename\n    }\n    status {\n      __typename\n    }\n    originalTask {\n      __typename\n    }\n    creationType {\n      __typename\n    }\n    assignedTo {\n      __typename\n    }\n  }\n}\n\nfragment TaskDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskDifference {\n    title {\n      ...DiffItem_diff\n    }\n    description {\n      ...DiffItem_diff\n    }\n    status {\n      ...DiffItem_diff\n    }\n    originalTask {\n      ...DiffItem_diff\n    }\n    creationType {\n      ...DiffItem_diff\n    }\n    assignedTo {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskFirstLabelingDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskFirstLabelingDifference {\n    difficulty {\n      __typename\n    }\n    unitDs {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    answerType {\n      __typename\n    }\n  }\n}\n\nfragment TaskFirstLabelingDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskFirstLabelingDifference {\n    difficulty {\n      ...DiffItem_diff\n    }\n    unitDs {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskHintFeedbackDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskHintFeedbackDifference {\n    hint {\n      __typename\n    }\n    specialAnswer {\n      __typename\n    }\n    special {\n      __typename\n    }\n    general {\n      __typename\n    }\n    incorrect {\n      __typename\n    }\n    correct {\n      __typename\n    }\n  }\n}\n\nfragment TaskHintFeedbackDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskHintFeedbackDifference {\n    hint {\n      ...DiffItem_diff\n    }\n    specialAnswer {\n      ...DiffItem_diff\n    }\n    special {\n      ...DiffItem_diff\n    }\n    general {\n      ...DiffItem_diff\n    }\n    incorrect {\n      ...DiffItem_diff\n    }\n    correct {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskHintFeedbackPublishDialog_task on Task {\n  id\n  hint {\n    id\n    text\n  }\n  submitFeedback {\n    id\n    specialAnswer\n    special\n    general\n  }\n}\n\nfragment TaskHistoryDialog_taskHistory on TaskHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...TaskProblemTypingDifferenceCounterLabel_difference\n    ...TaskProblemTypingDifferenceItemList_difference\n    ...TaskProblemCreationDifferenceCounterLabel_difference\n    ...TaskProblemCreationDifferenceItemList_difference\n    ...TaskImageCreationDifferenceCounterLabel_difference\n    ...TaskImageCreationDifferenceItemList_difference\n    ...TaskFirstLabelingDifferenceItemList_difference\n    ...TaskFirstLabelingDifferenceCounterLabel_difference\n    ...TaskSecondLabelingDifferenceItemList_difference\n    ...TaskSecondLabelingDifferenceCounterLabel_difference\n    ...TaskPublishDifferenceItemList_difference\n    ...TaskPublishDifferenceCounterLabel_difference\n    ...TaskVideoDifferenceCounterLabel_difference\n    ...TaskVideoDifferenceItemList_difference\n    ...TaskSolutionVideoDifferenceCounterLabel_difference\n    ...TaskSolutionVideoDifferenceItemList_difference\n    ...TaskHintFeedbackDifferenceItemList_difference\n    ...TaskHintFeedbackDifferenceCounterLabel_difference\n    ...TaskDifferenceItemList_difference\n    ...TaskDifferenceCounterLabel_difference\n  }\n}\n\nfragment TaskHistoryTimelineItem_taskHistory on TaskHistory {\n  created\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  type\n}\n\nfragment TaskImageCreationDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskImageCreationDifference {\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n  }\n}\n\nfragment TaskImageCreationDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskImageCreationDifference {\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskMigrateDialog_task on Task {\n  id\n  course {\n    id\n    year\n  }\n  publishedUnitDs(order: {order: DESC}) {\n    id\n    description\n    nextUnitD {\n      id\n      description\n    }\n    previousUnitD {\n      id\n      description\n    }\n  }\n}\n\nfragment TaskMigrationPairSyncDialog_task on Task {\n  id\n  isMigrated\n  migrationPair {\n    id\n    sequence\n  }\n  problem {\n    problem\n    solution\n    creationType\n    id\n  }\n  aiFile {\n    key\n    size\n    objectUrl\n    id\n  }\n}\n\nfragment TaskProblemCreationDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemCreationDifference {\n    answerType {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n  }\n}\n\nfragment TaskProblemCreationDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemCreationDifference {\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskProblemTypingDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemTypingDifference {\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n  }\n}\n\nfragment TaskProblemTypingDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemTypingDifference {\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskPublishDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskPublishDifference {\n    difficulty {\n      __typename\n    }\n    unitDs {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    answerType {\n      __typename\n    }\n  }\n}\n\nfragment TaskPublishDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskPublishDifference {\n    difficulty {\n      ...DiffItem_diff\n    }\n    unitDs {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskSecondLabelingDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSecondLabelingDifference {\n    difficulty {\n      __typename\n    }\n    unitDs {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    answerType {\n      __typename\n    }\n  }\n}\n\nfragment TaskSecondLabelingDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSecondLabelingDifference {\n    difficulty {\n      ...DiffItem_diff\n    }\n    unitDs {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskSolutionVideoDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSolutionVideoDifference {\n    isPremium {\n      before\n      after\n    }\n    isRecommended {\n      before\n      after\n    }\n    taskVideoTitle {\n      before\n      after\n    }\n    thumbnailHorizontalUrl {\n      before\n      after\n    }\n    thumbnailVerticalUrl {\n      before\n      after\n    }\n  }\n}\n\nfragment TaskSolutionVideoDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSolutionVideoDifference {\n    taskVideoTitle {\n      ...DiffItem_diff\n    }\n    isPremium {\n      ...DiffItem_diff\n    }\n    thumbnailHorizontalUrl {\n      ...DiffItem_diff\n    }\n    thumbnailVerticalUrl {\n      ...DiffItem_diff\n    }\n    isRecommended {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskStatusLabel_task on Task {\n  status\n}\n\nfragment TaskTaskHistoryPaginator_task on Task {\n  histories(order: {created: DESC}, first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...TaskHistoryDialog_taskHistory\n        ...TaskHistoryTimelineItem_taskHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment TaskVideoDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskVideoDifference {\n    description {\n      before\n      after\n    }\n    teacherName {\n      before\n      after\n    }\n    title {\n      before\n      after\n    }\n    type {\n      before\n      after\n    }\n  }\n}\n\nfragment TaskVideoDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskVideoDifference {\n    title {\n      ...DiffItem_diff\n    }\n    description {\n      ...DiffItem_diff\n    }\n    teacherName {\n      ...DiffItem_diff\n    }\n    type {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "4cab63d3d7d242bc358c2244bd6a5376";

export default node;
